import {
  isLoadableDisplayPreviewUrl,
  isManagedStorageUrl,
  isSignedDisplayUrl,
} from '@/utils/imageDisplayAccess';

function isDurableManagedCanonical(url) {
  const s = String(url || '').trim();
  return Boolean(s && isManagedStorageUrl(s) && !isSignedDisplayUrl(s));
}

function pickReferencePreviewEntry(previews, refs, index) {
  const preview = String(previews[index] || '').trim();
  const ref = String(refs[index] || '').trim();
  // 详情长期停留：优先可重新签名的受管 canonical，避免 referencePreviews 过期签名/临时 https 裂图
  if (isDurableManagedCanonical(ref)) return ref;
  if (preview && isLoadableDisplayPreviewUrl(preview)) return preview;
  if (isDurableManagedCanonical(preview)) return preview;
  return ref || preview;
}

/**
 * 从任务 result 解析单张原图的可展示地址。
 * 优先 durable /uploads canonical；未过期签名 view 次之；外链最后。
 */
export function resolveImageCropReferencePreviewMap(task) {
  const map = new Map();
  if (!task || typeof task !== 'object') return map;

  const imageIds = Array.isArray(task.imageIds) ? task.imageIds.map(String) : [];
  const result = task.result && typeof task.result === 'object' ? task.result : {};
  const previews = Array.isArray(result.referencePreviews) ? result.referencePreviews : [];
  const refs = Array.isArray(result.referenceUrls) ? result.referenceUrls : [];
  const sourceMap = result.sourceImageUrls && typeof result.sourceImageUrls === 'object'
    ? result.sourceImageUrls
    : {};

  imageIds.forEach((imageId, index) => {
    const fromSource = String(sourceMap[imageId] || sourceMap[String(imageId)] || '').trim();
    const preview = pickReferencePreviewEntry(previews, refs, index);
    const resolved = preview || fromSource;
    if (resolved) map.set(String(imageId), resolved);
  });
  return map;
}

export function resolveImageCropReferencePreview(task, imageId) {
  if (imageId == null) return '';
  return resolveImageCropReferencePreviewMap(task).get(String(imageId)) || '';
}

/**
 * 详情页原图 tile 的 displayUrl：
 * - 优先 batch API 刚 enrich 的 originalDisplayUrl
 * - 否则仅在 reference 为「未过期签名 view」时使用（立刻可显示）
 * - 受管 canonical 不作为 displayUrl，交给 SignedImage 现签，避免脏缓存
 */
export function resolveImageCropOriginalTileDisplayUrl(row, referencePreview = '') {
  const apiDisplay = String(row?.originalDisplayUrl || '').trim();
  if (apiDisplay && isLoadableDisplayPreviewUrl(apiDisplay)) return apiDisplay;

  const preview = String(referencePreview || '').trim();
  if (preview && isSignedDisplayUrl(preview) && isLoadableDisplayPreviewUrl(preview)) {
    return preview;
  }
  return '';
}
